var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageHeader reportHeader"},[_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',[_vm._t("title",function(){return [_vm._v("Something goes here")]})],2)])])]),_vm._v(" "),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('hr')])])
}]

export { render, staticRenderFns }